module.exports = __webpack_public_path__ + "static/logo-dark-3b80c9a700139f348d6bcf14a3612b11.png";